module.exports = __webpack_public_path__ + "img/statistics-bg-5.4dad43ca.png";